import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getInvoiceProgress } from "api/invoice.api";

export const useGetInvoiceStatus = () => {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ["invoice-status"],
    queryFn: () => getInvoiceProgress(),
    initialData: () => queryClient.getQueryData(["invoice-status"]),
    select: (data) => data.formattedInvoices,
    staleTime: 1000 * 60 * 10,
    onError: (error) => {
      console.error("Error fetching invoice status");
    },
  });
};
